export default "__VITE_ASSET__VRHX9LqD__"